import { render } from "./colorPicker.vue?vue&type=template&id=f71380c0"
import script from "./colorPicker.vue?vue&type=script&lang=js"
export * from "./colorPicker.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./colorPicker.vue?vue&type=style&index=0&id=f71380c0&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__